import type { PlayerState } from "./types.ts";

// Core owns roster order and theme identity; only this presentation is rotated.
// A mirrored side pair surrounds one evenly spaced top row, never a lower seat.
type SeatPosition = "left" | "top" | "right";

interface OpponentSeat {
  player: PlayerState;
  themeIndex: number;
  position: SeatPosition;
  fraction: number;
}

export function opponentSeats(players: readonly PlayerState[], viewerId: string): OpponentSeat[] {
  const selfIndex = players.findIndex((player) => player.id === viewerId);
  const count = players.length - (selfIndex >= 0 ? 1 : 0);
  // A non-seated viewer keeps Core order and may see all eight players.
  const hasSides = count >= 3;
  const topCount = count - (hasSides ? 2 : 0);
  const seats: OpponentSeat[] = [];
  for (let offset = 0; offset < count; offset++) {
    const themeIndex = (selfIndex + offset + 1) % players.length;
    const position = hasSides && offset === 0 ? "left"
      : hasSides && offset === count - 1 ? "right" : "top";
    const topIndex = offset - (hasSides ? 1 : 0);
    seats.push({
      player: players[themeIndex]!,
      themeIndex,
      position,
      fraction: position === "top" ? (topIndex + 1) / (topCount + 1) : 0.5,
    });
  }
  return seats;
}
